import { ApiClient } from "../ApiClient";
import config from "../utils/config";
class SuppliersClient {
    constructor() {
        this.apiClient = new ApiClient(`${config.gatewayApiUrl}/v2/suppliers`);
    }
    getMyAuctions() {
        return this.apiClient.get("/me/auctions");
    }
    getMyItems(query) {
        return this.apiClient.get(`/me/items?${new URLSearchParams(query)}`);
    }
    getBids(query) {
        return this.apiClient.get(`/me/bids?${new URLSearchParams(query)}`);
    }
}
const suppliersClient = new SuppliersClient();
export default suppliersClient;
